import $ from 'jquery';

let youtubePlayerApiPromise;

export const YOUTUBE_STATE_PLAYING = 1,
             YOUTUBE_STATE_BUFFERING = 3;

// Get a Promise of the YT player API.
export function getYouTubePlayerApi() {
    if(youtubePlayerApiPromise !== undefined)
        return youtubePlayerApiPromise;

    if(window.YT)
        return youtubePlayerApiPromise = new Promise(
            (resolve) => resolve(window.YT));

    return youtubePlayerApiPromise = new Promise((resolve, reject) => {
        // Don't overwrite existing listeners for YT loading
        let previousApiReadyCallback = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = function() {
            var YT = window.YT;

            if(!YT)
                reject('onYouTubeIframeAPIReady() called without YT loaded');
            else
                resolve(YT);

            // Play nicely with anyone else loading the YT api
            if(typeof previousApiReadyCallback === 'function')
                previousApiReadyCallback();
        }

        // If a listener function was already defined assume the script
        // is already being loaded by someone else.
        if(typeof previousApiReadyCallback !== 'function') {
            $.ajax({
              url: 'https://www.youtube.com/iframe_api',
              dataType: 'script',
              cache: true
            });
        }
    });
}



/** WEBPACK FOOTER **
 ** ./js/view/components/lightbox/youtube-player-api.js
 **/